/*
 * © Copyright 2014 – 2025 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import React from 'react';
import {STATUS_TYPE} from '../../../../ux/ux';
import {captureFingerprint, loginFingerprint, fingerprintAvailable, RESULT_CODES} from '../../../../api/devices/fingerprint-device.api';
import t from '../../../../i18n/locale-keys';

const fingerprintTestVersion = {version: 1};

class FingerprintTest extends React.PureComponent {
    constructor(props) {
        super(props);

        this.props.setTestButtonAvailability(false);

        this.props.registerPromise(fingerprintAvailable()
            ).then((captureMethod) => {
                if (captureMethod === RESULT_CODES.OLD_CAPTURE) {
                    this.captureFingerprintOld();
                }
                else if (captureMethod === RESULT_CODES.NEW_CAPTURE) {
                    this.captureFingerprintNew()
                }
                else {
                    // we should not be here
                    this.props.markTestComplete(false, captureMethod);
                }
			})
            .catch((error) => {
                this.props.markTestComplete(false, error)
            });
    }

    render() {
        return null;
    }

    captureFingerprintOld() {
         return this.props.registerPromise(
                 captureFingerprint()
             )
             .then((capture) => {
                 this.props.doTestLogon({capture}, true);
             })
             .catch((error) => {
                 this.props.markTestComplete(false, error);
             });        
    }

    captureFingerprintNew() {
        this.props.doTestLogon(fingerprintTestVersion).then((data) => {
            const {cert, nonce, version} = data;
            if (cert && nonce) {
                this.props.showStatus(t.fingerPlace(), STATUS_TYPE.INFO);
                this.props.registerPromise(
                    loginFingerprint(undefined, {cert, nonce, version})
                ).then((deviceServiceInitialResponse) => {
                    if (deviceServiceInitialResponse.result === RESULT_CODES.MORE_DATA) {
                        this.props.doTestLogon(deviceServiceInitialResponse).then((serverMoreDataResponse) => {
                            const {iv, message, tag} = serverMoreDataResponse;
                            this.props.showStatus(t.fingerPlace(), STATUS_TYPE.INFO);
                            this.props.registerPromise(
                                loginFingerprint(undefined, {iv, message, tag, status: RESULT_CODES.MORE_DATA})
                            ).then((data) => {
                                const {iv, message, result, tag, version} = data;
                                const logonData = {iv, message, result, tag, version};
                                this.props.doTestLogon(logonData);
                            }).catch((error) => {
                                // Different error types: .msg (server), .message (JS exception), string (application threw)
                                const message = error.msg || error.message || error;
                                this.props.markTestComplete(false, message, STATUS_TYPE.ERROR);
                            });
                        })
                    }
                    else {
                        this.props.markTestComplete(false, t.unknownError(), STATUS_TYPE.ERROR);
                    }
                }).catch((error) => {
                    // Different error types: .msg (server), .message (JS exception), string (application threw)
                    const message = error.msg || error.message || error;
                    this.props.markTestComplete(false, message, STATUS_TYPE.ERROR);
                });
            }
            else {
                this.props.markTestComplete(false, t.unknownError(), STATUS_TYPE.ERROR);
            }
        });
    }
}

export default FingerprintTest;
